import { render, staticRenderFns } from "./new.vue?vue&type=template&id=16bf0ed8&scoped=true"
import script from "./new.vue?vue&type=script&lang=js"
export * from "./new.vue?vue&type=script&lang=js"
import style0 from "../../../assets/css/input.css?vue&type=style&index=0&id=16bf0ed8&prod&scoped=true&lang=css&external"
import style1 from "./new.vue?vue&type=style&index=1&id=16bf0ed8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bf0ed8",
  null
  
)

export default component.exports